import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { artificialIntelligenceData } from '../../data/departmentalData/artificialIntelligence';

const ArtificialIntelligence = () => {
  return <TemplatePage data={artificialIntelligenceData} />;
};

export default ArtificialIntelligence;
